import { UnknownAction, combineReducers } from "redux";

import { AppState } from "@shared/interfaces";
import { AuthReducer } from "@containers/Auth/store/reducer";
import { SharedReducer } from "@shared/store/reducer";
import { CasesReducer } from "@containers/Cases/store/reducer";
import { UsersReducer } from "@containers/Users/store/reducer";
import { EvaluationReducer } from "@containers/Evaluation/store/reducer";

export default () => {
  const appReducer = combineReducers({
    auth: AuthReducer,
    shared: SharedReducer,
    cases: CasesReducer,
    users: UsersReducer,
    evaluation: EvaluationReducer,
  });

  return (state: AppState | undefined, action: UnknownAction) => {
    return appReducer(state, action);
  };
};
